<main>
  <div class="search-wrapper">
    <div class="search-bar-wrapper">
      <div class="search-bar">
        <input
          type="text"
          class="form-control"
          placeholder="Search"
          [(ngModel)]="keyword"
          (ngModelChange)="filterMatchingTenants()"
        />
        <i class="fa-solid fa-magnifying-glass"></i>
      </div>
    </div>

    <div class="tenants-filter-options">
      <!-- Filter Tenants by License status -->
      <div class="dropdown license-status">
        <label for="licenseStatus">License Status</label>
        <button
          type="button"
          class="form-control dropdown-toggle"
          id="licenseStatus"
          data-bs-toggle="dropdown"
        >
          {{ licenseStatusOption ?? "Any" }}
        </button>
        <ul class="dropdown-menu w-100">
          <li>
            <button
              type="button"
              class="dropdown-item"
              [class.selected]="!licenseStatusOption"
              (click)="updateLicenseStatusOption(undefined)"
            >
              Any
            </button>
          </li>
          @for (licenseStatus of AVAILABLE_LICENSE_STATUS; track $index) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="licenseStatusOption === licenseStatus"
                (click)="updateLicenseStatusOption(licenseStatus)"
              >
                {{ licenseStatus }}
              </button>
            </li>
          }
        </ul>
      </div>

      <!-- Sort Tenants -->
      <div class="dropdown sort-option">
        <label for="sortOption">Sort By</label>
        <button
          type="button"
          id="sortOption"
          class="form-control dropdown-toggle"
          data-bs-toggle="dropdown"
        >
          {{ sortOption }}
        </button>
        <ul class="dropdown-menu w-100">
          @for (option of AVAILABLE_SORT_OPTIONS; track option) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="sortOption === option"
                (click)="updateSortOption(option)"
              >
                {{ option }}
              </button>
            </li>
          }
        </ul>
      </div>
    </div>
  </div>

  <section class="tenants">
    @if (shownTenants.length > 0) {
      @for (tenant of shownTenants; track tenant.id) {
        <oaibox-license-client-row
          class="flex-fill"
          [tenant]="tenant"
        ></oaibox-license-client-row>
      }
    } @else {
      <div class="empty-list">
        <strong class="text-muted fs-5">No Tenants</strong>
      </div>
    }
  </section>
</main>
